import { Menu } from '@mantine/core'
import { featureFlags } from '@seen/core/featureFlags'
import { toast, useFeatureFlag } from '@seen/react'
import { IconPlug, IconPlugConnected } from '@tabler/icons-react'
import type { JSX } from 'react'
import { useMintMcpConnection } from '#src/mcp/useMintMcpConnection.ts'

/*
 * Account-menu toggle for the user's per-user OAuth connection to the remote MCP
 * server. Gated per-practitioner by the `mcp-remote-tools` feature flag; the
 * OAuth token is custodied in the browser. Injected into the avatar dropdown via
 * the app shell's `accountMenuItems` slot.
 */
export function McpAccountMenuItem(): JSX.Element | null {
  const mcpEnabled = useFeatureFlag(featureFlags.mcpRemoteTools)
  const { connected, connect, disconnect } = useMintMcpConnection()

  if (!mcpEnabled) {
    return null
  }

  return (
    <Menu.Item
      leftSection={
        connected ? (
          <IconPlugConnected size={14} stroke={1.5} />
        ) : (
          <IconPlug size={14} stroke={1.5} />
        )
      }
      onClick={() => {
        if (connected) {
          disconnect()
          toast.success('Disconnected MCP tools')
          return
        }
        void connect().catch(() => {
          toast.error('Could not start the MCP connection')
        })
      }}
    >
      {connected ? 'Disconnect MCP tools' : 'Connect MCP tools'}
    </Menu.Item>
  )
}
